import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ProductService } from '../../../../../../admin/src/app/services/product.service';
import { Manual } from '../../../../../../admin/src/app/models/manual';
import { ManualContent } from '../../../../../../admin/src/app/models/manual-content';
import { Asset } from '../../../../../../admin/src/app/models/asset';
import { DomSanitizer } from '@angular/platform-browser';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-product-manual',
  templateUrl: './product-manual.component.html',
  styleUrls: ['./product-manual.component.css']
})
export class ProductManualComponent implements OnInit, OnDestroy {

  productId: string;

  manual: Manual;

  localizedManual: ManualContent[];

  currentContent: number;

  zoomImage: Asset;

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private productSvc: ProductService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Product manual');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getManuals();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getManuals() {
    this.productSvc.getManuals(this.productId).subscribe(data => {
      this.manual = Object.assign([], data.payload.elements).shift();
      let lang = this.translate.currentLang;
      let defaultLength = this.translate.defaultLang;
      this.localizedManual = !!this.manual ? this.manual.contents.filter(c => c.lang === lang) : [];
      if (!this.localizedManual || this.localizedManual.length < 2) {
        this.localizedManual = !!this.manual ? this.manual.contents.filter(c => c.lang === defaultLength) : [];
      }
    });
  }

  isTitle(content: ManualContent) {
    return content.type === ManualContent.Types.Title;
  }

  isText(content: ManualContent) {
    return content.type === ManualContent.Types.Text;
  }

  isImage(content: ManualContent) {
    return content.type === ManualContent.Types.Image;
  }

  isVideo(content: ManualContent) {
    return content.type === ManualContent.Types.Video;
  }

  isFile(content: ManualContent) {
    return content.type === ManualContent.Types.File;
  }

  isYouTube(content: ManualContent) {
    return content.type === ManualContent.Types.YouTube;
  }

  safeYouTubeUrl(content: ManualContent) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(content.url);
  }

  zoomIn(asset: Asset) {
    this.zoomImage = asset;
  }

  zoomOut() {
    this.zoomImage = null;
  }

  filename(url: string): string {
    const i = url.lastIndexOf('/');
    return url.substr(i + 1);
  }

}
